import React, { useContext, useEffect, useState } from 'react';
import { DateRangePicker, Range } from 'react-date-range';
import {    
    Modal, 
    Button,
    
} from 'react-bootstrap';

 import { 
     //addDays , 
     format} from 'date-fns';

import { DataTableContext } from '../Common/DataTable/DataTableState';
import { toast } from './../../utils/Toaster';

interface DateRangeRenderState {
    show:boolean;
    emptyDate: Range[];
    selectedDate:Range[];
    dateRangeStr:string;
    startTime: string;
    endTime: string;
}

interface PayloadExportModalProps {
    handleClose: () => void;
    show: boolean;
    DataTableContextObj?: any;
    deviceWithRef?: boolean
}



const PayloadExportModal: React.FC<PayloadExportModalProps> = ( props ) => {
    const DataTableContextObj = useContext(DataTableContext);

    const emptyDate = {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection'
    }
    
    const initState = {
            show:false,
            emptyDate: [emptyDate],
            selectedDate:[emptyDate],
            dateRangeStr: '',
            startTime: '00:00',
            endTime: '23:59',
    }

    const [state, setState] = useState<DateRangeRenderState>(initState);

    //let urlValue = getUrlValue(DataTableContextObj, column.filterField);
 
    //Sun May 08 2022 00:13:10 GMT+0530 (India Standard Time)
    //Sun May 0 0000 00:00:00 GMT+0530 (India Standard Time)
    
    // Validate times when date changes
    useEffect(() => {
        const startDate = state.selectedDate[0].startDate;
        const endDate = state.selectedDate[0].endDate;

        // Only validate if both dates are the same day
        if (startDate && endDate && (new Date(startDate)).toLocaleDateString() === (new Date(endDate)).toLocaleDateString()) {
            const startTimeMinutes = timeToMinutes(state.startTime);
            const endTimeMinutes = timeToMinutes(state.endTime);

            if (startTimeMinutes > endTimeMinutes) {
                toast.warning('Start time cannot be greater than end time on the same day.');
            }
        }
    }, [state.selectedDate]);
      const setCalenderToggle = () => {

            props.handleClose()
      }



    // Helper to convert time string to minutes
    const timeToMinutes = (timeStr: string) => {
        const [hoursStr, minutesStr] = timeStr.split(':');
        const hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);
        return (hours * 60) + minutes;
    };

      /**
       * endDate: Tue May 24 2022 00:00:00 GMT+0530 (India Standard Time) {}
        key: "selection"
        startDate: Tue May 24 2022 00:00:00 GMT+0530 (India Standard Time) {}
        [[Prototype]]: Object
       * 
      */
    const setSelectedDateHandler = ( item ) => {
            
            
            setState(prevState => { 
                return {...prevState, selectedDate: item}
            });

            // const setCalenderToggle = () => {
            //     setState(prevState => { 
            //         return {...prevState, selectedDate: item}
            //     });
            // }
           
    }

    const applySearch = () => {
        
        //https://cto-playground.dev.orbiwise.com/uiapi/rest/export/payloads?download_filename=payloads.csv&tz=-330&payload_from_date=2022-06-14T18:30:00.000Z&payload_to_date=2022-07-25T18:29:59.999Z
        let startDate = new Date(state.selectedDate[0].startDate);
        let endDate = new Date(state.selectedDate[0].endDate);

        // Parse time fields
        const startTimeSplit = state.startTime.split(":").map(v => parseInt(v));
        const endTimeSplit = state.endTime.split(":").map(v => parseInt(v));

        // Set the hours and minutes from the time selectors
        startDate.setHours((startTimeSplit[0] ?? 0), (startTimeSplit[1] ?? 0), 0, 0);
        endDate.setHours((endTimeSplit[0] ?? 23), (endTimeSplit[1] ?? 59), 59, 999);

        // Validate: if same day, startTime cannot be after endTime
        const startDateFmt = format(startDate, 'yyyy-MM-dd');
        const endDateFmt = format(endDate, 'yyyy-MM-dd');
        if (startDateFmt === endDateFmt) {
            const startTimeMinutes = timeToMinutes(state.startTime);
            const endTimeMinutes = timeToMinutes(state.endTime);
            if (startTimeMinutes > endTimeMinutes) {
                toast.warning('Start time cannot be after end time on the same day.');
                return;
            }
        }

        // Convert to ISO strings
        const startDateISOFmt = startDate.toISOString();
        const endDateISOFmt = endDate.toISOString();

        var queryStr = '';
    
        queryStr += '&payload_from_date=';
        queryStr += startDateISOFmt;

        queryStr += '&payload_to_date=';
        queryStr += endDateISOFmt;
    
        // if there are selected rows then add them to the query string, let's use searchState.selectedRowIds[].deviceUuid
        let searchState = props.DataTableContextObj?.searchState || DataTableContextObj?.searchState;

        if (searchState?.selectedRowIds?.length > 0) {
            const selectedRowIds = searchState.selectedRowIds
                .map(item => item.deviceUuid ?? item.deveui)
                .filter(Boolean);
        
            const queryKey = searchState.selectedRowIds.some(item => item.deviceUuid) ? 'deviceuuids' : 'deveui';
            queryStr += `&${queryKey}=${selectedRowIds.join(',')}`;
        }

        var url = window.location.protocol;
        var tz = "&tz=" + (new Date()).getTimezoneOffset();
        url += '//';
        url += window.location.host;
        let downloadUrl = url + '/uiapi/rest/export/payloads?download_filename=payloads.csv' + tz + queryStr;
        if(props.deviceWithRef) {
            downloadUrl = url + '/uiapi/rest/export/devicesWithRefs?download_filename=devicesWithRef.csv' + tz + queryStr;
        }
        
        window.location.assign(downloadUrl);
        //close popup after 1 sec
        setTimeout(() => {
            props.handleClose();
        },1000)
        

    }

    const clearSearch = () => {
        
        setState(prevState => {
            return {...prevState, show:!state.show, selectedDate:[emptyDate], dateRangeStr:'', startTime: '00:00', endTime: '23:59'}
        });

    }

    
    //from_date=2021-12-16T00:00:00%2B05:30
    //2021-12-27 12:52:00 GMT+5:30 - 2021-12-30 12:52:00 GMT+5:30     

    ///format(new Date(2014, 1, 11), 'yyyy-MM-dd h:I:SS Z');
    //const formatPattern = 'yyyy-MM-dd h:I:SS z';
    let display = (props.show) ? '' : 'none';

    const DateRangePickerAny: any = DateRangePicker;        // FIXME:

      return (
            <div style={{display: display}}>
                <input type="text" 
                                className='form-control form-control-sm'
                                onClick={setCalenderToggle} 
                                onChange={ (e) => {  } }
                                value={state.dateRangeStr}  
                                placeholder={`Search Date`} />
                <Modal
                        show={props.show}
                        onHide={props.handleClose}
                        size="xl"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                                Export Payloads
                            </Modal.Title>
                        </Modal.Header>
                            <Modal.Body>
                                <small>You are about to export payloads for all devices which may result in a very large download. Please limit the export to the relevant time range.</small>
                                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginTop: '15px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <label htmlFor="startTime" style={{ fontWeight: 500, color: '#333', marginRight: '2px' }}>Start Time</label>
                                        <input
                                            id="startTime"
                                            type="time"
                                            value={state.startTime}
                                            className='time-picker'
                                            style={{
                                                width: '120px',
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                                fontSize: '1rem',
                                                color: '#333',
                                                background: '#f9f9f9',
                                                boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                                            }}
                                            onChange={e => {
                                                const { selectedDate, endTime } = state;
                                                const startDate = selectedDate[0].startDate;
                                                const endDate = selectedDate[0].endDate;
                                                const newStartTime = e.target.value;
                                                if (startDate && endDate && (new Date(startDate)).toLocaleDateString() === (new Date(endDate)).toLocaleDateString()) {
                                                    const endTimeMinutes = timeToMinutes(endTime);
                                                    const startTimeMinutes = timeToMinutes(newStartTime);
                                                    if (startTimeMinutes > endTimeMinutes) {
                                                        toast.warning('Start time cannot be greater than end time on the same day.');
                                                        return;
                                                    }
                                                }
                                                setState(prev => ({ ...prev, startTime: newStartTime }));
                                            }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <label htmlFor="endTime" style={{ fontWeight: 500, color: '#333', marginRight: '2px' }}>End Time</label>
                                        <input
                                            id="endTime"
                                            type="time"
                                            value={state.endTime}
                                            className='time-picker'
                                            style={{
                                                width: '120px',
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                                fontSize: '1rem',
                                                color: '#333',
                                                background: '#f9f9f9',
                                                boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                                            }}
                                            onChange={e => {
                                                const { selectedDate, startTime } = state;
                                                const startDate = selectedDate[0].startDate;
                                                const endDate = selectedDate[0].endDate;
                                                const newEndTime = e.target.value;
                                                if (startDate && endDate && (new Date(startDate)).toLocaleDateString() === (new Date(endDate)).toLocaleDateString()) {
                                                    const endTimeMinutes = timeToMinutes(newEndTime);
                                                    const startTimeMinutes = timeToMinutes(startTime);
                                                    if (endTimeMinutes < startTimeMinutes) {
                                                        toast.warning('End time cannot be less than start time on the same day.');
                                                        return;
                                                    }
                                                }
                                                setState(prev => ({ ...prev, endTime: newEndTime }));
                                            }}
                                        />
                                    </div>
                                </div>
                                <DateRangePickerAny
                                    onChange={item => setSelectedDateHandler([item.selection])}
                                    moveRangeOnFirstSelection={true}
                                    editableDateInputs={false}
                                    months={2}
                                    direction="horizontal"
                                    ranges={state.selectedDate}
                                />
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="dark" onClick={applySearch}>Download</Button>
                                <Button variant="outline-dark" onClick={clearSearch}>Clear</Button>
                                <Button variant="outline-dark"  onClick={setCalenderToggle}>Close</Button>
                            </Modal.Footer>
                        </Modal>
            </div>
        );
     
}

export default PayloadExportModal;